import { render } from "./BuildJobs.vue?vue&type=template&id=78348ef6"
const script = {}

import "./BuildJobs.vue?vue&type=style&index=0&id=78348ef6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__